import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Radio, message } from 'antd';
import { completeWorkOrder, WorkOrderQueryResponse } from '@/api/workorder';

interface CompleteModalProps {
  open: boolean;
  record: WorkOrderQueryResponse;
  onClose: () => void;
  onSuccess: () => void;
}

const CompleteModal: React.FC<CompleteModalProps> = ({ open, record, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const isInstallOrReplace = record.orderType === 'install' || record.orderType === 'replace_core';
  // 从工单描述中解析已有的计费模式
  const existingMode = (() => {
    const m = (record.description || '').match(/计费模式[:：]([^|]+)/);
    return m ? (m[1].includes('按天') ? 'days' : 'flow') : '';
  })();

  useEffect(() => {
    if (open) {
      form.resetFields();
      if (existingMode) {
        form.setFieldsValue({ billingMode: existingMode });
      }
    }
  }, [open, form, existingMode]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const payload: any = {
        id: record.id,
        remark: values.remark,
      };
      // 安装/换芯工单完成时传入计费模式
      if (isInstallOrReplace && values.billingMode) {
        payload.billingMode = values.billingMode;
      }
      const resp = await completeWorkOrder(payload);
      if (resp.success) {
        messageApi.success('操作成功');
        onSuccess();
      } else {
        messageApi.error(resp.errorMsg || '操作失败');
      }
    } catch {}
  };

  return (
    <>
      {contextHolder}
      <Modal
        title={`完成工单 - ${record.orderNo || ''}`}
        open={open}
        onOk={handleOk}
        onCancel={onClose}
        okText="确定"
        cancelText="取消"
        maskClosable={false}
        destroyOnHidden
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          {isInstallOrReplace && (
            <Form.Item label="计费模式" name="billingMode"
              rules={[{ required: true, message: '请选择计费模式' }]}
              tooltip="完成后净水机将按所选模式开始计费，仅可设置一次"
            >
              <Radio.Group disabled={!!existingMode}>
                <Radio value="flow">按流量计费</Radio>
                <Radio value="days">按天计费</Radio>
              </Radio.Group>
            </Form.Item>
          )}
          <Form.Item label="处理备注" name="remark" rules={[{ required: true, message: '请输入处理备注' }]}>
            <Input.TextArea rows={4} placeholder="请输入处理备注" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CompleteModal;
